<template>
  <v-card elevation="4">
    <v-card-title class="d-flex justify-space-between">
      <span>{{ $t('fleet_health_ui.marked_as_fixed')}}</span>
      <info-modal width="800">
        <v-card-title>
          <h4>{{ $t('fleet_health_ui.marked_as_fixed') }}</h4>
        </v-card-title>
        <v-card-text v-html="$t('fleet_health_ui.modal_info.marked_as_fixed', { numDays: 30 })"/>
      </info-modal>
    </v-card-title>
    <v-card-text v-if="!loading">
      <div v-if="fixedVehicles.length > 0">
        <div class="pb-2">{{ $t('fleet_health_ui.fixed_vehicles_lead_in', {numDays: '30'}) }}</div>
        <div v-if="!showAllCustomers">
          <v-chip
            v-for="(vehicle, index) in fixedVehicles" :key="index"
            class="mr-2 mb-2"
            :to="'/vehicle/' + vehicle.id">
            <v-icon class="mr-2">mdi-truck</v-icon>
            {{ vehicle.name }}
          </v-chip>
        </div>
        <div v-else>
          <div v-for="(vehicles, customerName) in fixedVehiclesByCustomer" :key="customerName" class="my-2">
            <h6>{{ customerName }}</h6>
            <v-chip
              v-for="(vehicle, index) in vehicles" :key="index"
              class="mr-2 mb-2"
              :to="'/vehicle/' + vehicle.id">
              <v-icon class="mr-2">mdi-truck</v-icon>
              {{ vehicle.name }}
            </v-chip>
          </div>
        </div>
      </div>
      <div v-else>
        <div>{{ $t('fleet_health_ui.no_vehicles_marked_as_fixed', {numDays: '30'}) }}</div>
      </div>
    </v-card-text>
    <v-card-text v-else>
      <v-skeleton-loader type="text" width="50%" class="mb-2"/>
      <div class="d-flex">
        <v-skeleton-loader type="chip" class="mr-2" v-for="i in 3" :key="i"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'
import InfoModal from '@/components/shared/InfoModal'
import { map, each, has } from 'lodash'
import Moment from 'moment-timezone'

export default {
  name: 'VehiclesMarkedAsFixed',
  components: {
    InfoModal
  },
  mixins: [
    CurrentUserMixin
  ],
  props: {
    showAllCustomers: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fixedVehicles: [],
      loading: true
    }
  },
  mounted () {
    this.fetchData()
  },
  watch: {
    showAllCustomers () {
      this.fetchData()
    }
  },
  computed: {
    fixedVehiclesByCustomer () {
      const result = {}
      each(this.fixedVehicles, vehicle => {
        const key = vehicle.primary_customer.name
        if (!has(result, key)) {
          result[key] = []
        }
        result[key].push(vehicle)
      })
      return result
    }
  },
  methods: {
    /**
     * Retrieve the data from the API
     */
    async fetchData () {
      this.loading = true
      try {
        const customerIds = this.showAllCustomers ? (map(this.regularCustomers, x => x.id)).join(',') : this.customerContext.id
        const resp = await this.$orm('Vehicle')
          .findAll({
            expand: 'primary_customer',
            customer_id: customerIds,
            marked_as_fixed_after: Moment().tz('UTC').subtract(30, 'days').format()
          })
        this.fixedVehicles = resp.getItems()
      } catch (error) {
        this.handleError(error)
      } finally {
        this.loading = false
      }
    },
    /**
     * Refresh the page when the customer context changes.
     */
    customerContextChangeHandler () {
      this.fetchData()
    }
  }
}
</script>

<style scoped>
</style>
